import { useCallback, useEffect, useMemo, useState, Suspense, } from "react";
import { deleteItem, deleteMultipleItem, fetchData, toggleStatus, } from "../../../utils/apiUtils";
import { DeleteButton, PlusButton } from "../../../helper/ImageFormat";
import DeleteModel, { confirmBulkDelete } from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import ShippingPartnerTable from "./ShippingPartnerTable";
import { ShippingPartnerModal } from "../../../Model/Model";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
const ShippingPartner = () => {
    const [loading, setLoading] = useState(true);
    const [shipping, setshipping] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [search, setSearch] = useState("");
    const [deleteItemId, setDeleteItemId] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [updatedata, setupdatedata] = useState(null);
    const [selected, setSelected] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const totalPages = useMemo(() => Math.ceil(totalCount / perPage), [totalCount, perPage]);
    const handleEditClick = (data) => {
        setEditingId(data.id);
        const { createdAt, id, updatedAt, ...otherData } = data;
        setupdatedata(otherData);
        setModalOpen(true);
    };
    const fetchshipping = useCallback(
        async (page = 1, searchQuery = "") => {
            setLoading(true);
            await fetchData(
                "shipping-partner",
                { perPage, pageNo: page, search: searchQuery },
                setshipping,
                setTotalCount,
                setCurrentPage,
                setLoading
            );
        },[perPage]);
    useEffect(() => {
        const delay = search ? 500 : 0;
        const handler = setTimeout(() => {
            fetchshipping(currentPage, search);
        }, delay);

        return () => clearTimeout(handler);
    }, [search, perPage,currentPage,fetchshipping]);



    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };
    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("shipping-partner", deleteItemId?.id, fetchshipping, [deleteItemId?.flag]);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (err) {
            throw err;
        } finally {
            setIsDeleting(false);
        }
    };
    const handleStatusToggle = async (shipping) => {
        const data = await toggleStatus(
            "shipping-partner-status",
            shipping?.id,
            fetchshipping
        );
        if (Object.keys(data).length > 0) {
            setshipping((prevshipping) =>
                prevshipping.map((curr) =>
                    curr.id === shipping.id ? { ...curr, isActive: data?.isActive } : curr
                )
            );
        }
    };
    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            // fetchshipping(page);
            setCurrentPage(page);
        }
    };
    const toggleModal = () => {
        setModalOpen(!modalOpen);
        setEditingId(false);
        setupdatedata({});
    };
    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Shipping Partners", path: "*" },
    ];
    const handlebulkDelete = async () => {
        await confirmBulkDelete({
            itemType: "Shipping Partner",
            selectedIds: selected,
            deleteApiCall: (ids) => deleteMultipleItem("bulk/shipping-partner", ids),
            refreshCallback: fetchshipping,
        });
    };


    return (
        <>
            <div className="content-wrapper">
                <div
                    className="page-header mt-5"
                    style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3 className="custom-page-title">Shipping Partners</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div
                    className="d-flex justify-content-between mb-2"
                    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}>
                    <PerPageSelect value={perPage} onChange={setPerPage}/>

                    <div style={{ display: "flex", gap: "20px" }}>
                           <TableSearch value={search} onChange={setSearch} />

                        <PlusButton handleAdd={toggleModal} module={"Shipping partner"} />
                        {selected && selected?.length > 0 && (
                            <DeleteButton
                                handleAdd={handlebulkDelete}
                                name={"selected Shipping Partner"}
                                module={"Shipping partner"}
                            />
                        )}
                    </div>
                </div>

                <ShippingPartnerTable
                    loading={loading}
                    shipping={shipping}
                    currentPage={currentPage}
                    perPage={perPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    handlePageClick={handlePageClick}
                    handleEditClick={handleEditClick}
                    handleDelete={handleDelete}
                    handleStatusToggle={handleStatusToggle}
                    selected={selected}
                    setSelected={setSelected}
                />
            </div>

            <Suspense fallback={<div>Loading...</div>}>
                {modalOpen && (
                    <ShippingPartnerModal
                        modalOpen={modalOpen}
                        toggleModal={toggleModal}
                        editingId={editingId}
                        setEditingId={setEditingId}
                        setupdatedata={setupdatedata}
                        updatedata={updatedata}
                        fetchshipping={fetchshipping}
                    />
                )}
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <DeleteModel
                    deleteModalOpen={deleteModalOpen}
                    setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                    onConfirm={confirmDelete}
                    itemName="Shipping partner"
                    isDeleting={isDeleting}
                />
            </Suspense>
        </>
    );
};

export default ShippingPartner;
